import React, { Component } from "react";
import axios from "axios";
import FeatherIcon from "feather-icons-react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";

class DaystaffForm extends Component {
  state = {
    days: [],
    Daystaffs: [],
    isChecked: [],
    error: "",
  };

  edit = () => {
    this.getDays();
    this.getDaystaffs();
  };

  handleInputCheckbox = (e, day) => {
    const checked = e.target.checked;
    const actif = checked ? day.id : 0;

    this.setState((prevState) => ({
      isChecked: {
        ...prevState.isChecked,
        [day.id]: checked,
      },
    }));

    const data = {
      staffId: this.props.staffId,
      actif: String(actif),
      dayId: day.id,
    };

    axios
      .post("daystaffs", data)
      .then((response) => {
        this.getDaystaffs();
        toast(response?.data?.msg, {
          theme: "light",
          style: { backgroundColor: "blue", color: "white" },
        });
      })
      .catch((error) => {
        this.setState({
          error: error.response?.data?.msg || "Une erreur est survenue",
        });

        toast(error.response?.data?.msg, {
          theme: "light",
          style: { backgroundColor: "red", color: "white" },
        });
      });
  };

  getDays = async () => {
    const request = await axios.get("days");

    if (request.status === 200) {
      this.setState({
        days: request.data,
      });
    }
  };

  getDaystaffs = async () => {
    const request = await axios.get("daystaffs/staffId/" + this.props.staffId);

    if (request.status === 200) {
      const checkedDays = [];

      request.data.forEach((item) => {
        if (item.actif > 0) {
          checkedDays[item.dayId] = true;
        }
      });

      this.setState({
        Daystaffs: request.data,
        isChecked: checkedDays,
      });
    }
  };

  render() {
    const userdaystaffs = this.state.days.map((day) => (
      <label
        htmlFor={`daystaff-${day.id}`}
        className="m-1 d-flex align-items-center border rounded-pill px-3 py-2 cursor-pointer"
        key={day.id}
      >
        <input
          type="checkbox"
          className="rounded me-2"
          checked={
            this.state.isChecked[day.id]
              ? true
              : this.state.Daystaffs?.filter(
                  (val) => val.dayId === day.id && val.actif > 0
                ).length > 0
          }
          onChange={(e) => this.handleInputCheckbox(e, day)}
          id={`daystaff-${day.id}`}
        />

        <FeatherIcon icon="calendar" size={15} className="text-primary me-2" />

        <span className="font-monospace fw-normal">{day.day}</span>
      </label>
    ));

    return (
      <div>
        <Modal
          show={this.props.isModal}
          onHide={() => this.props.showModal(false)}
          onEntered={this.edit}
          backdrop="static"
          centered
          contentClassName="student-form-modal student-form-modal--compact"
        >
          <Modal.Header>
            <div className="student-form__heading">
              <span className="student-form__heading-icon">
                <FeatherIcon icon="calendar" size="20" />
              </span>

              <div>
                <span className="student-form__eyebrow">
                  Disponibilité hebdomadaire
                </span>
                <Modal.Title>
                  Personnel {this.props.staffName || ""}
                </Modal.Title>
              </div>
            </div>
          </Modal.Header>

          <Modal.Body className="student-form__body">
            {this.state.error && (
              <div className="student-form__alert" role="alert">
                <FeatherIcon icon="alert-circle" size="17" />
                <span>{this.state.error}</span>
              </div>
            )}

            <div className="student-form__section-title">
              <span>
                <FeatherIcon icon="clock" size="16" />
              </span>

              <div>
                <strong>Disponibilités hebdomadaires</strong>
                <small>
                  Sélectionnez les jours où ce membre du personnel est disponible.
                </small>
              </div>
            </div>

            <div className="input-group pt-2 flex-wrap">
              {userdaystaffs}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <span className="student-form__footer-note">
              <FeatherIcon icon="info" size="14" /> Les choix sont enregistrés
              automatiquement
            </span>

            <button
              type="button"
              onClick={() => this.props.showModal(false)}
              className="btn btn-light student-form__button"
            >
              <FeatherIcon icon="x" size="16" /> Fermer
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default DaystaffForm;
